import { useEffect, useRef } from "react";

// Re-runs `cb` whenever the tab/window regains focus or becomes visible again,
// so a page shows fresh data when the user returns to it after editing elsewhere.
export function useRefreshOnFocus(cb) {
  const ref = useRef(cb);
  ref.current = cb;
  useEffect(() => {
    const run = () => { if (document.visibilityState === "visible") ref.current?.(); };
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", run);
    return () => {
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", run);
    };
  }, []);
}
